import {
  all,
  put,
  select,
  takeEvery,
} from "redux-saga/effects";
import {
  MAIN_CONTAINER_WIDGET_ID,
} from "constants/WidgetConstants";
import type { ReduxAction } from "ee/constants/ReduxActionConstants";
import {
  ReduxActionTypes,
} from "ee/constants/ReduxActionConstants";
import {
  getWidgetByName,
  getWidgetIdsByType,
  getWidgetsMeta,
} from "sagas/selectors";
import type {
  FlattenedWidgetProps,
} from "reducers/entityReducers/canvasWidgetsReducer";
import { updateWidgetMetaPropAndEval } from "actions/metaActions";
import {
  closePropertyPane,
  focusWidget
} from "actions/widgetActions";
import log from "loglevel";
import { flatten } from "lodash";
import { selectWidgetInitAction } from "actions/widgetSelectionActions";
import { SelectionRequestType } from "./WidgetSelectUtils";
import { getOverlayWidgetType } from "selectors/widgetSelectors";
import { getWidgetSelectionBlock } from "selectors/ui";

export function* closeOverlaySaga(
  action: ReduxAction<{ overlayName?: string; exclude?: string }>,
) {
  try {
    const { overlayName } = action.payload;

    let widgetIds: string[] = [];
    if (overlayName) {
      const widget: FlattenedWidgetProps | undefined = yield select(
        getWidgetByName,
        overlayName,
      );

      widgetIds = widget ? [widget.widgetId] : [];
      yield put(closePropertyPane());
    } else {
      const metaProps: Record<string, any> = yield select(getWidgetsMeta);
      const overlayWidgetType : string = yield select(getOverlayWidgetType);
      const modalWidgetIds: string[] = yield select(
        getWidgetIdsByType,
        overlayWidgetType ,
      );

      modalWidgetIds.forEach((widgetId: string) => {
        if (metaProps[widgetId] && metaProps[widgetId].isVisible) {
          widgetIds.push(widgetId);
        }
      });
    }

    widgetIds = action.payload.exclude
      ? widgetIds.filter((id: string) => id !== action.payload.exclude)
      : widgetIds;
    if (widgetIds) {
      yield all(
        flatten(
          widgetIds.map((widgetId: string) => {
            return [
              put(updateWidgetMetaPropAndEval(widgetId, "isModalOpen", false)),
            ];
          }),
        ),
      );
    }

    if (overlayName) {
      const isWidgetSelectionBlocked: boolean = yield select(
        getWidgetSelectionBlock,
      );

      if (!isWidgetSelectionBlocked) {
        yield put(selectWidgetInitAction(SelectionRequestType.Empty));
        yield put(focusWidget(MAIN_CONTAINER_WIDGET_ID));
      }
    }
  } catch (error) {
    log.error(error);
  }
}

export default function* overlaySagas() {
  yield all([
    takeEvery(ReduxActionTypes.CLOSE_OVERLAY, closeOverlaySaga)
  ]);
}
